export type FolderJSON = {
  id: number;
  estate_id?: number;
  parent_folder_id?: number;
  name?: string;
  num_items?: number;
};

export class Folder {
  static path = "folders";
  constructor(
    public id?: number,
    public estateId?: number,
    public parentFolderId?: number,
    public name?: string,
    public numItems?: number,
    public itemsType?: string,
    public clickHandler?: () => void
  ) {}

  static fromJSON = (json: FolderJSON): Folder => {
    return new Folder(
      json.id,
      json.estate_id,
      json.parent_folder_id,
      json.name,
      json.num_items
    );
  };
}
